import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var sessionToken = require("../constants/credentials");
var Parse = require("parse");
var Jobin = require("../Jobin");
var Business = require("./Business");
var Date = require("./Date");
/**
 * Contains functions for calling and declaring
 *
 * @class Jobin.History
 * @static
 * @hideconstructor
 */

/**
 * Get a user friendly action string
 * @method getHistoryOfJob
 * @name Jobin.History.getHistoryOfJob
 * @param {string} jobId
 * @returns {Array} JSON array
 */

export function getHistoryOfJob(_x) {
  return _getHistoryOfJob.apply(this, arguments);
}
/**
 * Change the price to pay to the Jober
 * @method postNote
 * @name Jobin.History.postNote
 * @param {ParseObject} job
 * @param {string} note
 * @returns {boolean} Success
 */
function _getHistoryOfJob() {
  _getHistoryOfJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(job) {
    var currentUser, CRMHistory, query, result, tempArray, i, json;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context.sent;
          if (!(currentUser || sessionToken.getToken())) {
            _context.next = 32;
            break;
          }
          CRMHistory = Parse.Object.extend("CRMHistory");
          query = new Parse.Query(CRMHistory);
          query.equalTo("Job", job);
          query.include(["CRMUser.Name", "CRMUser.Lastname", "CRMUser.Image"]);
          query.descending("createdAt");
          _context.prev = 9;
          _context.next = 12;
          return query.find();
        case 12:
          result = _context.sent;
          tempArray = [];
          i = 0;
        case 15:
          if (!(i < result.length)) {
            _context.next = 23;
            break;
          }
          _context.next = 18;
          return createHistoryJSON(result[i]);
        case 18:
          json = _context.sent;
          if (json) {
            tempArray.push(json);
          }
        case 20:
          i++;
          _context.next = 15;
          break;
        case 23:
          return _context.abrupt("return", {
            status: "ok",
            result: tempArray
          });
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](9);
          console.error(_context.t0);
          return _context.abrupt("return", {
            status: "error",
            result: "Necesitas verificarte antes de poder realizar la consulta"
          });
        case 30:
          _context.next = 33;
          break;
        case 32:
          return _context.abrupt("return", {
            status: "error",
            result: "Necesitas verificarte antes de poder realizar la consulta"
          });
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[9, 26]]);
  }));
  return _getHistoryOfJob.apply(this, arguments);
}
export function postNote(_x2, _x3) {
  return _postNote.apply(this, arguments);
}
function _postNote() {
  _postNote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(job, note) {
    var result;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return Parse.Cloud.run("addJobComment", {
            jobId: job.id,
            comment: note,
            sessionToken: sessionToken.getToken()
          });
        case 3:
          result = _context2.sent;
          if (!result) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return", {
            status: "ok",
            result: true
          });
        case 8:
          return _context2.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de añadir una nueva nota."
          });
        case 9:
          _context2.next = 15;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);
          return _context2.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de añadir una nueva nota."
          });
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 11]]);
  }));
  return _postNote.apply(this, arguments);
}
function createHistoryJSON(_x4) {
  return _createHistoryJSON.apply(this, arguments);
}
function _createHistoryJSON() {
  _createHistoryJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(history) {
    var payment, user, type, extraInfo, job, jobType, json, _json, jober, _json2, _json3, _job, _jobType, _json4, _json5, review, _json6, _json7, _json8, _json9, _json10, _json11, result, _json12, _json13, _json14, _json15, _json16, _json17;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          payment = history.get("Payment");
          if (payment) payment.fetch();
          user = history.get("CRMUser");
          type = history.get("Type");
          extraInfo = history.get("ExtraInfo");
          if (!(type === "newJob")) {
            _context3.next = 14;
            break;
          }
          _context3.next = 8;
          return history.get("Job").fetch();
        case 8:
          job = _context3.sent;
          jobType = job.get("JobType");
          json = {
            title: "Nuevo trabajo",
            description: jobType === "fixed" ? "Nuevo trabajo de precio cerrado publicado" : jobType === "transport" ? "Nuevo trabajo de transporte publicado" : "Nuevo lead publicado",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", json);
        case 14:
          if (!(type === "freezeJob")) {
            _context3.next = 19;
            break;
          }
          _json = {
            title: "Trabajo congelado",
            description: "El trabajo fue congelado",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json);
        case 19:
          if (!(type === "aceptoT")) {
            _context3.next = 27;
            break;
          }
          _context3.next = 22;
          return history.get("User").fetch();
        case 22:
          jober = _context3.sent;
          _json2 = {
            title: "Nuevo Woller",
            description: "Se ha asignado a " + jober.get("Name") + " a este trabajo",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json2);
        case 27:
          if (!(type === "sendToTransit")) {
            _context3.next = 32;
            break;
          }
          _json3 = {
            title: "En reparto",
            description: "Se ha enviado este pedido a reparto",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json3);
        case 32:
          if (!(type === "modifyExtras")) {
            _context3.next = 41;
            break;
          }
          _context3.next = 35;
          return history.get("Job").fetch();
        case 35:
          _job = _context3.sent;
          _jobType = _job.get("JobType");
          _json4 = {
            title: _jobType === "fixed" ? "Extras añadidos" : "Peso añadido",
            description: _jobType === "fixed" ? "Se han añadido nuevos extras" : "El peso ha pasado de " + extraInfo.oldWeight + " Kg a " + extraInfo.newWeight + " Kg",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json4);
        case 41:
          if (!(type === "finalizado")) {
            _context3.next = 46;
            break;
          }
          // TODO: CHECK IF ITS POSSIBLE TO SHOW JOBER ONLY ON LEADS
          // const jober = await history.get("User").fetch();
          _json5 = {
            title: "Servicio finalizado",
            description: "Se ha marcado el servicio como finalizado",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json5);
        case 46:
          if (!(type === "review")) {
            _context3.next = 54;
            break;
          }
          _context3.next = 49;
          return history.get("Review").fetch();
        case 49:
          review = _context3.sent;
          _json6 = {
            title: "Nueva valoración - " + review.get("Stars") + " estrellas",
            description: review.get("Text"),
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json6);
        case 54:
          if (!(type === "cancelJob")) {
            _context3.next = 59;
            break;
          }
          _json7 = {
            title: "Servicio cancelado",
            description: extraInfo.eliminado ? "Se ha marcado el servicio como cancelado por el cliente." : "Se ha marcado el servicio como falso.",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json7);
        case 59:
          if (!(type === "cancelTransportation")) {
            _context3.next = 64;
            break;
          }
          _json8 = {
            title: "Servicio cancelado",
            description: "El transporte ha sido cancelado",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json8);
        case 64:
          if (!(type === "addComment")) {
            _context3.next = 69;
            break;
          }
          _json9 = {
            title: "Nota",
            description: extraInfo.newNotes,
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json9);
        case 69:
          if (!(type === "changeMethod")) {
            _context3.next = 74;
            break;
          }
          _json10 = {
            title: "Método de pago modificado",
            description: "Se ha modificado el método de pago de " + extraInfo.oldMethod + " a " + extraInfo.newMethod,
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json10);
        case 74:
          if (!(type === "modifyJoberPrice")) {
            _context3.next = 79;
            break;
          }
          _json11 = {
            title: "Precio de Woller",
            description: "Se ha modificado el precio del Woller por este servicio a " + (extraInfo.newJoberPrice * 1.21).toFixed(2) + "€.",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json11);
        case 79:
          if (!(type === "modifyBusiness")) {
            _context3.next = 92;
            break;
          }
          _context3.next = 82;
          return Business.getById(extraInfo.newBusiness);
        case 82:
          result = _context3.sent;
          if (!(result.status === "ok")) {
            _context3.next = 88;
            break;
          }
          _json12 = {
            title: "Negocio asignado",
            description: "Se ha seleccionado " + result.result.get("Name") + " como negocio de esta solicitud",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json12);
        case 88:
          _json13 = {
            title: "Negocio asignado",
            description: "Se ha seleccionado un nuevo negocio a esta solicitud",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json13);
        case 90:
          _context3.next = 113;
          break;
        case 92:
          if (!(type === "fixed" || type === "transportation")) {
            _context3.next = 97;
            break;
          }
          _json14 = {
            title: "Pago registrado",
            description: "Nuevo pago registrado de " + (payment.get("Price") * 1.21).toFixed(2) + " €",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json14);
        case 97:
          if (!(type === "modifyAppointment")) {
            _context3.next = 102;
            break;
          }
          _json15 = {
            title: "Cita asignada",
            description: "Se ha asignado el día " + Date.toLargeFormat(extraInfo.newAppointment).result + " como cita para el servicio.",
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json15);
        case 102:
          if (!(type === "attachFile")) {
            _context3.next = 107;
            break;
          }
          _json16 = {
            title: "Nuevo archivo adjunto",
            description: extraInfo.newFiles.map(function (file) {
              return "url: <a href=\"".concat(file, "\" target=\"_blank\">").concat(file.split("_")[1], "</a>");
            }),
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json16);
        case 107:
          if (!(type === "removeFile")) {
            _context3.next = 112;
            break;
          }
          _json17 = {
            title: "Archivo adjunto eliminado",
            description: "url: <a href=\"".concat(extraInfo.oldFile.url(), "\" target=\"_blank\">").concat(extraInfo.oldFile.name(), "</a>"),
            createdAt: history.createdAt,
            user: user
          };
          return _context3.abrupt("return", _json17);
        case 112:
          return _context3.abrupt("return", null);
        case 113:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _createHistoryJSON.apply(this, arguments);
}